import { RoutePath } from '@business/seller';
var ConnectionPaths = RoutePath.ConnectionPaths;
var getSubmoduleRelativePaths = RoutePath.Utils.getSubmoduleRelativePaths;
var ConnectionRelativePaths = getSubmoduleRelativePaths(ConnectionPaths, ConnectionPaths.CONNECTION_ROOT_PATH);
export default ConnectionRelativePaths;